import React from 'react';

/** Label shown beside a seat count when the client has trial access. */
export const TRIAL_ACCESS_LABEL = 'Trial Access';

/**
 * "used/total seats", plus a Trial Access chip for trial clients. Trial
 * clients have unlimited seats, so the ratio is informational there; it is
 * still shown so the same display keeps working once billing is live.
 */
export default function SeatCount({
  used,
  total,
  isTrial,
  suffix = ''
}: {
  used: number | null | undefined;
  total: number | null | undefined;
  isTrial: boolean;
  /** Appended after the ratio, e.g. " seats" or " seats used". */
  suffix?: string;
}) {
  return (
    <span className="seat-count">
      <span>
        {used ?? 0}/{total ?? 0}
        {suffix}
      </span>
      {isTrial && <span className="chip pos">{TRIAL_ACCESS_LABEL}</span>}
    </span>
  );
}
